import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Caption from '../../../../Theme/Fonts/Caption'
import { AffiliationProps } from '..'
import FlagImage from '../../../../BaseComponents/Image/Flag'

const Affiliation: FunctionComponent<AffiliationProps> = ({
    affiliation,
    imageUrl,
    alt,
}): ReactElement => (
    <Grid horizontal minWidth={0} centerVertical>
        <Grid noExpand marginRight={2} height={18}>
            <FlagImage width={18} imageUrl={imageUrl} alt={alt} size="S" />
        </Grid>
        <Grid minWidth={0}>
            <Caption color="keshi-3" numberOfLines={1}>
                {affiliation}
            </Caption>
        </Grid>
    </Grid>
)

export default Affiliation
